<template>
    <div>
      <router-view />
      <full-screen />
    </div>
</template>

<style lang="scss">
@import './common/common.css';
.readAloudAndHighlight {
  color: red !important;
}
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: 16px;
}

.pt20 {
  padding-top: 20px;
}

.pb20 {
  padding-bottom: 20px;
}

.pb30 {
  padding-bottom: 30px;
}

.pb40 {
  padding-bottom: 40px;
}

.pb60 {
  padding-bottom: 60px;
}

.btn-1 {
  background-color: var(--cg);
  color: #fff;
  text-align: center;
  border: 2px solid var(--cg);
  border-radius: 50px;
}

.btn-2 {
  background-color: #fff;
  color: var(--cg);
  text-align: center;
  border: 2px solid var(--cg);
  border-radius: 50px;
}

.btn-3 {
  background-color: #fff;
  color: var(--co);
  text-align: center;
  border: 2px solid var(--co);
  border-radius: 50px;
}

image,
video {
  vertical-align: bottom;
}

.scroll-view {
  box-sizing: border-box;
}

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-right: 20px;
}

.mr-40 {
  margin-right: 40px;
}

.image24 {
  --w: 24px;
  width: var(--w);
  height: var(--w);
}

.image20 {
  --w: 20px;
  width: var(--w);
  height: var(--w);
}

.image16 {
  --w: 16px;
  width: var(--w);
  height: var(--w);
}

.image32 {
  --w: 32px;
  width: var(--w);
  height: var(--w);
}

.image64 {
  --w: 64px;
  width: var(--w);
  height: var(--w);
}

.image84 {
  --w: 84px;
  width: var(--w);
  height: var(--w);
}

.image100 {
  --w: 100px;
  width: var(--w);
  height: var(--w);
}

.image120 {
  --w: 120px;
  width: var(--w);
  height: var(--w);
}

.image150 {
  --w: 150px;
  width: var(--w);
  height: var(--w);
}

.image {
  width: var(--w);
  height: var(--w);
}

.image30 {
  --w: 30px;
  width: var(--w);
  height: var(--w);
}

.image36 {
  --w: 36px;
  width: var(--w);
  height: var(--w);
}

.image40 {
  --w: 40px;
  width: var(--w);
  height: var(--w);
}

.image48 {
  --w: 48px;
  width: var(--w);
  height: var(--w);
}

.image50 {
  --w: 50px;
  width: var(--w);
  height: var(--w);
}

.image60 {
  --w: 60px;
  width: var(--w);
  height: var(--w);
}

.vvt20+.vvt20 {
  margin-top: 20px;
}

.vvt30+.vvt30 {
  margin-top: 30px;
}

.vvt40+.vvt40 {
  margin-top: 40px;
}

.vvt60+.vvt60 {
  margin-top: 60px;
}

.po-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.po-fill {
  position: absolute;
  inset: 0;
}

.z-max {
  z-index: 98;
}

.z-max-1 {
  z-index: 999;
}

.po-re {
  position: relative;
}

.zwxx {
  color: #999;
  font-size: 28px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.borrr-10 {
  border-radius: 10px;
}

.borrr-20 {
  border-radius: 20px;
}

.borrr-50 {
  border-radius: 50px;
}

.bg--c {
  background-color: var(--cg);
}

.bg-fff {
  background-color: #fff;
}

.bg-999 {
  background-color: #999;
}

.bg-f1 {
  background-color: #F1F1F1;
}

.text-hidden-1 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.text-hidden-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.text-hidden-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.text-hidden-4 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.text-hidden-6 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.color-999 {
  color: #999999;
}

.color-76 {
  color: #767676;
}

.color-61 {
  color: #616161;
}

.color-1a {
  color: #03267E;
}

.color-9e {
  color: #9e9e9e;
}

.color--c {
  color: var(--cg);
}

.color-warn {
  color: var(--co);
}

.fs20 {
  font-size: 20px;
}

.fs12 {
  font-size: 12px;
}

.fs10 {
  font-size: 10px;
}

.fs14 {
  font-size: 14px;
}

.fs24 {
  font-size: 24px;
}

.fs28 {
  font-size: 28px;
}

.fs32 {
  font-size: 32px;
}

.fs30 {
  font-size: 30px;
}

.fs40 {
  font-size: 40px;
}

.fs48 {
  font-size: 48px;
}

.fs56 {
  font-size: 56px;
}

.fs15 {
  font-size: 15px;
}

.fs64 {
  font-size: 64px;
}

.fs72 {
  font-size: 72px;
}

.m20 {
  margin: 20px;
}

.mauto {
  margin: auto;
}

.ml10 {
  margin-left: 10px;
}

.ml20 {
  margin-left: 20px;
}

.ml30 {
  margin-left: 30px;
}

.ml40 {
  margin-left: 40px;
}

.ml60 {
  margin-left: 60px;
}

.mr10 {
  margin-right: 10px;
}

.mr20 {
  margin-right: 20px;
}

.mr30 {
  margin-right: 30px;
}

.mr40 {
  margin-right: 40px;
}

.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mt30 {
  margin-top: 30px;
}

.mt40 {
  margin-top: 40px;
}

.mt60 {
  margin-top: 60px;
}

.mt120 {
  margin-top: 120px;
}


.mb20 {
  margin-bottom: 20px;
}

.mb24 {
  margin-bottom: 24px;
}

.mb30 {
  margin-bottom: 30px;
}

.mb40 {
  margin-bottom: 40px;
}

.mb50 {
  margin-bottom: 50px;
}

.mb60 {
  margin-bottom: 60px;
}

.mb80 {
  margin-bottom: 80px;
}

.mb100 {
  margin-bottom: 100px;
}

.mb120 {
  margin-bottom: 120px;
}

.h100 {
  height: 100%;
}

.p30 {
  padding: 30px;
}

.pt30 {
  padding-top: 30px;
}

.p40 {
  padding: 40px;
}

.p20 {
  padding: 20px;
}
.p10 {
  padding: 10px;
}

.plr30 {
  padding-left: 30px;
  padding-right: 30px;
}
.plr20 {
  padding-left: 20px;
  padding-right: 20px;
}

.fs36 {
  font-size: 36px;
}

.fs26 {
  font-size: 26px;
}

.color-fff {
  color: #fff;
}
.color-8A {
  color: #8AB6FF;
}

.color-error {
  color: var(--error);
}

.fw {
  font-weight: bold;
}

.flex {
  display: flex;
}

.f1 {
  flex: 1;
}

.f2 {
  flex: 2;
}

.wrap {
  flex-wrap: wrap;
}

.column {
  flex-direction: column;
}

.al-center {
  align-items: center;
}

.al-end {
  align-items: flex-end;
}

.ju-between {
  justify-content: space-between;
}

.ju-center {
  justify-content: center;
}

.ju-around {
  justify-content: space-around;
}

.start {
  justify-content: start;
}

.ju-end {
  justify-content: flex-end;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.hidden {
  overflow: hidden;
}

.oy-auto {
  overflow-y: auto;
}

.ox-auto {
  overflow-x: auto;
}
</style>
<script>
import FullScreen from "@/components/full-screen.vue";
export default {
  name: "App",
  components: {
    FullScreen
  }
}
</script>
